import { render, staticRenderFns } from "./drug.parameters.vue?vue&type=template&id=0846f060&"
import script from "./drug.parameters.vue?vue&type=script&lang=js&"
export * from "./drug.parameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports